import { Selection } from 'src/projects/types/Selection.ts';

export const APP_ROUTE_MAP: Record<Selection['type'], string> = {
    actuators: 'actuator-sizing-and-selection',
    valves: 'sizing-and-selection',
    sensors: 'sensor-selection',
    retrofit_actuators: '',
    retrofit_sensors: '',
    retrofit_valves: '',
};

export const getAppRoutePrefix = (location: Location, to: Selection['type']) => {
    const match = location.pathname.match(/(^\/\w+\/shop\/\w+\/|^\/\w+\/\w+\/products\/retrofit-app\/)([^/]+)?/);
    const prefix = match && match[1];
    return `${prefix ?? ''}${APP_ROUTE_MAP[to] || ''}`;
};
